import { render, staticRenderFns } from "./AmeldingList.vue?vue&type=template&id=434bba66&scoped=true&"
import script from "./AmeldingList.vue?vue&type=script&lang=ts&"
export * from "./AmeldingList.vue?vue&type=script&lang=ts&"
import style0 from "./AmeldingList.vue?vue&type=style&index=0&id=434bba66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434bba66",
  null
  
)

export default component.exports